module.exports = __webpack_public_path__ + "img/Cupcake.0c17eb90.webp";